<template>
  <div class="container_bottom">
    <div>
      <el-footer class="footer-link">
        <!-- <router-link to="/">服务协议</router-link>|<router-link to="/">风险披露</router-link>|<router-link to="/">免责声明</router-link>|<router-link :to="{name:'contact'}">联系我们</router-link> -->
        <p>Copyright@2013-{{ year }} 钜丰金业有限公司 版权所有</p>
      </el-footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: ""
    };
  },
  methods: {
    _getYarn() {
      let _date = new Date();
      this.year = _date.getFullYear();
    }
  },
  mounted() {
    this._getYarn();
  }
};
</script>

<style>
.container_bottom {
  /* background: #96611a; */
  padding: 10px 0;
}

.footer-link {
  text-align: center;
  font-size: 14px;
  color: #595959;
}

.footer-link a {
  color: #595959;
  display: inline-block;
  margin: 0 5px;
  text-decoration: none;
}

.footer-link p {
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/common/footer.vue